<div style="padding-top: 15px">
  <a (click)="addPerson()" class="">Add Person</a>
  <select
    class="small"
    (change)="setPrefs(sortByLast)"
    [(ngModel)]="sortByLast"
    style="
      margin-top: 10px;
      border: none;
      background-color: #f8f8f8;
      display: block;
      margin-top: 10px;
      margin-left: -3px;
    ">
    <option [value]="null">Sort by default</option>
    <option [value]="false">Sort by First Name</option>
    <option [value]="true">Sort by Last Name</option>
  </select>
</div>
